import script from "./ThuChiAdminDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ThuChiAdminDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ThuChiAdminDashboard.vue?vue&type=style&index=0&id=35578a6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35578a6c"]])

export default __exports__